import { ModelBase } from './../../core/model/model-base';
import { RentalObjectCategory, RentalObjectCategoryToString } from './const/enums';

export class RentalObjectType extends ModelBase {
  category: RentalObjectCategory;
  get categoryCaption(): string {
    return RentalObjectCategoryToString(this.category);
  }

  pointsBvk91: number;

  name: string;

  numberOfRooms: number;

  rH91: number;

  isGarage: boolean;

  parkingHasElectricity: boolean;

  parkingHasRoof: boolean;

  toString() {
    return `${this.name}`;
  }
}
